import { useTranslation } from "react-i18next";
import { Link, NavLink, Outlet, useLocation } from "react-router-dom";

import { useContext, useEffect } from "react";
import { CommonContext } from "../../../App";
import DateFilter from "../../../Components/CommonComponent/Dropdown/DateFilter";
function TabButtonsTheftControl() {
  const { setDateRange } = useContext(CommonContext);
  const location = useLocation();
  const { t } = useTranslation();
  const tabs = [
    { title: t("deletedEntry"), path: "deleted-entry" },
    { title: t("updatedEntry"), path: "updated-entry" },
    { title: t("deleteLedgers"), path: "deleted-ledgers" },
    // { title: t("deletedGroup/SubGroup"), path: "purchase-table" },
  ];


  return (
    <div>
      <header className="tabs-header bg-theme-webBackground  bg- py-1 rounded  sticky top-0 z-[990]   flex gap-3 justify-between   ">
        <div className="flex gap-3">
          {tabs.map((tab) => {
            const isActive =
              location.pathname === "/web-setting/theft-controls" && tab.path === "deleted-entry"
                ? true
                : location.pathname.endsWith(tab.path);
            return (
              <NavLink
                key={tab.path}
                to={tab.path}
                className={`tab no-underline rounded-1 h-7 mt-[3px] pt-[3px] text-sm  px-2  ${isActive
                 ? `bg-theme-headerBg text-theme-color font-medium border-1 border-theme-headerBg`
                  : `text-theme-tabColor border-1  border-black hover:!border-theme-headerBg  hover:!text-theme-headerBg `
                  }`}
              >
                {tab.title}
              </NavLink>
            );
          })}
        </div>

        <div className="" >
          <DateFilter
            storageKey="reports"
             customMode="single"
             availableFilters={[ "today", "yesterday", "custom"]}
             onChange={(r) => setDateRange({
            startDate: r.startDate,
            endDate: r.startDate
          })} />

        </div>
      </header>

      <main className="tab-content">
        <Outlet />
      </main>
    </div>
  );
}

export default TabButtonsTheftControl;

